export default "__VITE_ASSET__B9Wb85rF__"